angular.module('eatself').filter('prix', function(dataStore,ShopService) {
	function numberWithSpaces(x) {
	    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}
	return function(p, def, curr, dec) {
		var shop = ShopService.shop;
		var currency = curr != undefined ? curr : shop && ShopService.CURRENCIES[shop.CurrencyCode] || '€';
		var decimals = dec !=undefined ? dec : shop?shop.CurrencyDecimals:2;
		def = def !=undefined ? def : '0 ' + currency
		// if (def === undefined) def = '\xa0'
		return +p && numberWithSpaces((+p).toFixed(decimals)).replace('.', ',') + ' ' + currency || def
	};
})
